// @flow strict

import * as React from 'react';

import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { selectFeatureFlag } from '@gandi/authentication';
import type { ApplicationSummary } from '@gandi/redux-resource-simplehosting';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';
import type { SimplehostingPriceSummary } from 'src/modules/simplehosting/prices';

import { hasEssentialOffer } from '../modules/prices';

import { Card } from './Card';

import styles from './Offers.scss';

export type OwnProps = {
  application?: ApplicationSummary,
  availableSizes: Array<SimplehostingPriceSummary>,
  onClick: SimplehostingPriceSummary => mixed,
  currency: string,
  popularSize?: string,
  packId: string,
};

export type Props = {
  ...OwnProps,
};

const featureFlagProps = {
  featureFlagName: 'ff-shs-legacy-creation',
};

export default function Offers({
  application,
  availableSizes,
  onClick,
  currency,
  popularSize,
  packId,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const FF_SHS_LEGACY_CREATION = useAppSelector(state =>
    selectFeatureFlag(state, featureFlagProps),
  );

  const withEssentialOffer = hasEssentialOffer(availableSizes);

  return (
    <>
      <Base
        grid
        className={clsx(
          styles.grid,
          withEssentialOffer ? styles.more : undefined,
        )}
        marginBottom={FF_SHS_LEGACY_CREATION ? 'base' : undefined}
      >
        {availableSizes.map(priceInfo => {
          const productName = priceInfo.product.name;
          const highlight = popularSize ? popularSize === productName : false;
          return (
            <Card
              application={application}
              currency={currency}
              withEssentialOffer={!!withEssentialOffer}
              highlight={highlight}
              key={productName}
              onClick={() => onClick(priceInfo)}
              packId={packId}
              priceInfo={priceInfo}
            />
          );
        })}
      </Base>

      {FF_SHS_LEGACY_CREATION && (
        <p>
          <Link to="/simplehosting/legacy">
            {__(
              'Click here to find former Simple Hosting instances from S+ to XXL',
            )}
          </Link>
        </p>
      )}

      <Base
        color="light"
        margin="none"
        size="small"
        tagName="p"
        flex
        flexCol
        flexAlignItemsCenter
        align="center"
      >
        {__(
          'Prices indicated for a one-year subscription. Domain names and mailboxes are free only when you choose from our catalog.',
        )}
        <br />
        {__('You can make your selection in the next step.')}
      </Base>
    </>
  );
}
